export default __webpack_public_path__ + "locales/pt-BR/Payments.json?hash=30ee4f1cd08b4a989f832ce8b6f7f6ff";